import { Blur } from '../Blur'
import { Heading } from '@homebotapp/hb-react-component-catalog'
import { formatCurrency } from '../../../helpers/formatters'

interface AvmModuleCurrencyDisplayProps {
  homeValue: number
  shouldBlur: boolean
}

export const AvmModuleCurrencyDisplay = ({ homeValue, shouldBlur }: AvmModuleCurrencyDisplayProps) => {
  return (
    <Heading as='h3' size='2xl' color='brand' fontWeight='light'>
      <Blur amount='lg' enabled={shouldBlur}>
        {formatCurrency(homeValue)}
      </Blur>
    </Heading>
  )
}
